import Component from "../abstracts/Component";

export default class LiveChatMiawComponent extends Component {
  get SELECTORS() {
    return {
      ctaMinimizeForMiaw: "[data-cta-minimize-for-miaw]",
      ctaPdpNotifyMe: "[data-pdp-notifyme]",
    };
  }

  get CLASSES() {
    return {
      ctaWithChatMiaw: "--with-chat",
    };
  }

  constructor(compEl) {
    super(compEl);
    this.liveChatMiawActive = document.body.getAttribute(
      "data-live-chat-miaw-active",
    );
    this.ctaMinimizeForMiaw = document.querySelectorAll(
      this.SELECTORS.ctaMinimizeForMiaw,
    );
    this.ctaPdpNotifyMe = document.querySelectorAll(
      this.SELECTORS.ctaPdpNotifyMe,
    );
  }

  bindEvents() {
    this.handleCtaWithChatMiaw();
  }

  handleCtaWithChatMiaw() {
    if (this.liveChatMiawActive !== "true") return;
    const embeddedBtn = document.getElementById(
      "embeddedMessagingConversationButton",
    );
    if (embeddedBtn) {
      this.handleCtaSize();
      return;
    }
    const observer = new MutationObserver((mutations) => {
      const hasEmbeddedMessaging = mutations.some((m) =>
        Array.from(m.addedNodes).some((n) => n.id === "embedded-messaging"),
      );

      if (hasEmbeddedMessaging) {
        this.handleCtaSize();
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: false });
  }

  handleCtaSize() {
    const embeddedBtn = document.getElementById(
      "embeddedMessagingConversationButton",
    );
    const isVisible =
      embeddedBtn && getComputedStyle(embeddedBtn).display !== "none";
    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    if (!isMobile) return;

    const applyChatClass = (element) => {
      if (
        element &&
        !element.classList.contains(this.CLASSES.ctaWithChatMiaw)
      ) {
        this.trackStickyZoneForCta(element);
      }
    };

    this.ctaMinimizeForMiaw.forEach((cta) => {
      applyChatClass(cta);
    });

    this.ctaPdpNotifyMe.forEach((cta) => {
      applyChatClass(cta);
    });
  }

  trackStickyZoneForCta(cta) {
    if (!cta) return;
    const rootTopMargin = window.innerHeight - 120;
    const options = {
      root: null,
      rootMargin: `-${rootTopMargin}px 0px 25px 0px`,
      threshold: 1,
    };
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        cta.classList.add(this.CLASSES.ctaWithChatMiaw);
      } else {
        cta.classList.remove(this.CLASSES.ctaWithChatMiaw);
      }
    }, options);

    observer.observe(cta);
  }

  render() {
    this.bindEvents();
  }
}
